import React, { useState } from "react";
import { Modal, Form, Button, Alert } from "react-bootstrap";
import Swal from "sweetalert2";
import "./ModalSeleccionarColumnasReporte.scss";

/**
 * Modal para seleccionar columnas a descargar en reporte de alumnos
 * @param {Object} props - Props del componente
 * @param {boolean} props.show - Mostrar u ocultar modal
 * @param {function} props.onHide - Callback al cerrar modal
 * @param {function} props.onDescargar - Callback con columnas seleccionadas
 */
export default function ModalSeleccionarColumnasReporte({ show, onHide, onDescargar }) {
  const [columnasSeleccionadas, setColumnasSeleccionadas] = useState({
    alu_rut: true,
    alu_dv: true,
    alu_nombres: true,
    alu_apellidos: true,
    alu_fnacimiento: false,
    ge_descripcion: false,
    alu_nacionalidad: false,
    alu_enfermedad: false,
    alu_tratamiento: false,
    ts_nombre: false,
    tpo_descripcion: false,
    tal_descripcion: false,
    tpa_descripcion: false,
    alu_alergia: false,
    alu_nombre_social: false,
    alu_tipo_documento: false,
    alu_fecha_vencimiento_documento: false,
    usu_email: true,
    usu_rut: true,
    usu_dv: false,
    usu_nombre: true,
    usu_apellido: true,
    usu_celular: false,
    par_descripcion: false,
    cem_rut: false,
    cem_nombres: false,
    cem_apellidos: false,
    cem_email: false,
    cem_celular: false,
    cem_parentesco: false
  });

  // Definición de columnas con sus etiquetas
  const columnasDisponibles = [
    { key: "alu_rut", label: "RUT Alumno", grupo: "Alumno" },
    { key: "alu_dv", label: "DV Alumno", grupo: "Alumno" },
    { key: "alu_nombres", label: "Nombres Alumno", grupo: "Alumno" },
    { key: "alu_apellidos", label: "Apellidos Alumno", grupo: "Alumno" },
    { key: "alu_fnacimiento", label: "Fecha Nacimiento", grupo: "Alumno" },
    { key: "ge_descripcion", label: "Género", grupo: "Alumno" },
    { key: "alu_nacionalidad", label: "Nacionalidad", grupo: "Alumno" },
    { key: "alu_nombre_social", label: "Nombre Social", grupo: "Alumno" },
    { key: "alu_tipo_documento", label: "Tipo Documento", grupo: "Alumno" },
    { key: "alu_fecha_vencimiento_documento", label: "Fecha Vencimiento Documento", grupo: "Alumno" },
    
    { key: "ge_descripcion", label: "Información Médica", grupo: "Información Médica" },
    { key: "alu_enfermedad", label: "Enfermedad", grupo: "Información Médica" },
    { key: "alu_tratamiento", label: "Tratamiento", grupo: "Información Médica" },
    { key: "ts_nombre", label: "Tipo Sangre", grupo: "Información Médica" },
    { key: "tpo_descripcion", label: "Talla Pollera", grupo: "Información Médica" },
    { key: "tal_descripcion", label: "Tipo Alimentación", grupo: "Información Médica" },
    { key: "tpa_descripcion", label: "Tipo Pasajero", grupo: "Información Médica" },
    { key: "alu_alergia", label: "Alergia", grupo: "Información Médica" },
    
    { key: "usu_email", label: "Email Apoderado", grupo: "Apoderado" },
    { key: "usu_rut", label: "RUT Apoderado", grupo: "Apoderado" },
    { key: "usu_dv", label: "DV Apoderado", grupo: "Apoderado" },
    { key: "usu_nombre", label: "Nombre Apoderado", grupo: "Apoderado" },
    { key: "usu_apellido", label: "Apellido Apoderado", grupo: "Apoderado" },
    { key: "usu_celular", label: "Celular Apoderado", grupo: "Apoderado" },
    { key: "par_descripcion", label: "Parentesco", grupo: "Apoderado" },
    
    { key: "cem_rut", label: "RUT Contacto Emergencia", grupo: "Contacto Emergencia" },
    { key: "cem_nombres", label: "Nombres Contacto Emergencia", grupo: "Contacto Emergencia" },
    { key: "cem_apellidos", label: "Apellidos Contacto Emergencia", grupo: "Contacto Emergencia" },
    { key: "cem_email", label: "Email Contacto Emergencia", grupo: "Contacto Emergencia" },
    { key: "cem_celular", label: "Celular Contacto Emergencia", grupo: "Contacto Emergencia" },
    { key: "cem_parentesco", label: "Parentesco Contacto Emergencia", grupo: "Contacto Emergencia" }
  ];

  // Agrupar columnas por grupo
  const gruposColumnas = {};
  columnasDisponibles.forEach(col => {
    if (!gruposColumnas[col.grupo]) {
      gruposColumnas[col.grupo] = [];
    }
    // Evitar duplicados
    if (!gruposColumnas[col.grupo].find(c => c.key === col.key)) {
      gruposColumnas[col.grupo].push(col);
    }
  });

  const handleToggleColumna = (key) => {
    setColumnasSeleccionadas(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const handleSelectAll = () => {
    const todosSeleccionados = Object.values(columnasSeleccionadas).every(v => v === true);
    const nuevoEstado = {};
    Object.keys(columnasSeleccionadas).forEach(key => {
      nuevoEstado[key] = !todosSeleccionados;
    });
    setColumnasSeleccionadas(nuevoEstado);
  };

  const handleDescargar = async () => {
    const columnasSeleccionadasArray = Object.keys(columnasSeleccionadas).filter(
      key => columnasSeleccionadas[key]
    );

    if (columnasSeleccionadasArray.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Sin columnas",
        text: "Debes seleccionar al menos una columna para descargar."
      });
      return;
    }

    onDescargar(columnasSeleccionadasArray);
    onHide();
  };

  const columnasSeleccionadasCount = Object.values(columnasSeleccionadas).filter(v => v === true).length;
  const columnasTotal = Object.keys(columnasSeleccionadas).length;

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="material-icons" style={{ marginRight: "10px" }}>
            download
          </i>
          Seleccionar Columnas para Descargar
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Alert variant="info" className="mb-3">
          <i className="material-icons" style={{ marginRight: "5px", fontSize: "18px" }}>
            info
          </i>
          Selecciona las columnas que deseas incluir en el reporte de Excel
        </Alert>

        <div className="mb-3">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <span className="font-weight-bold">
              Seleccionadas: {columnasSeleccionadasCount} de {columnasTotal}
            </span>
            <Button
              variant="link"
              size="sm"
              onClick={handleSelectAll}
              className="text-decoration-none"
            >
              {Object.values(columnasSeleccionadas).every(v => v === true)
                ? "Deseleccionar Todo"
                : "Seleccionar Todo"}
            </Button>
          </div>

          <div className="columnas-grupo-container">
            {Object.entries(gruposColumnas).map(([grupo, columnas]) => (
              <div key={grupo} className="columnas-grupo mb-3">
                <div className="grupo-titulo">
                  <strong>{grupo}</strong>
                </div>
                <div className="columnas-checkboxes">
                  {columnas.map(columna => (
                    <div key={columna.key} className="form-check columna-checkbox">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`col_${columna.key}`}
                        checked={columnasSeleccionadas[columna.key] || false}
                        onChange={() => handleToggleColumna(columna.key)}
                      />
                      <label className="form-check-label" htmlFor={`col_${columna.key}`}>
                        {columna.label}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancelar
        </Button>
        <Button
          variant="primary"
          onClick={handleDescargar}
          disabled={columnasSeleccionadasCount === 0}
        >
          <i className="material-icons" style={{ marginRight: "5px" }}>
            download
          </i>
          Descargar Reporte ({columnasSeleccionadasCount})
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
